<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <br />
      <div class="text-right">
        <button class="btn btn-danger inherit" v-if="info" data-toggle="modal" data-target="#delMenuModal"><i class="fa fa-trash" aria-hidden="true"></i></button>
        <br />
      </div>
      <br />
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>名稱
        </span>
          <input class="form-control" placeholder="" type="text" v-model="menuInfo.name" maxlength="32">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          菜單描述
        </span>
          <input class="form-control" placeholder="" type="text" v-model="menuInfo.description" maxlength="45">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          菜單備註
        </span>
          <input class="form-control" placeholder="" type="text" v-model="menuInfo.remark" maxlength="45">
        </div>
        <br />
      </div>
      <!-- /.box-body -->
    </div>
    <div class="box-footer text-center">
      <button
        class="btn btn-default btn-fail"
        @click="goToBack"
      >
        取消
      </button>
      <button class="btn btn-success" v-if="!info" @click="checkInputEmpty('cr')">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="checkInputEmpty('up')">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delMenuOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import matcherModal from '../../../elements/Modal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'MenuInfoFormTemp',
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      brandName: '',
      brandType: '',
      menuInfo: {
        name: '',
        description: '',
        remark: ''
      },
      delMenuOption: {
        id: 'delMenuModal',
        title: '刪除菜單',
        body: '1. 實際品項內容不會被刪除，仍可被重複利用<br>2. 菜單目前鎖定中或是上架中，無法執行更新<br><br>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '刪除',
            event: 'delMenu'
          }
        ]
      }
    }
  },
  extends: NdExtendHandleMenu,
  components: {
    'm-modal': matcherModal
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    menuInfoNew () {
      return {
        name: this.checkInput(this.menuInfo.name),
        description: this.checkInput(this.menuInfo.description),
        remark: this.checkInput(this.menuInfo.remark)
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    checkInputEmpty (type) {
      if (!this.menuInfoNew.name) {
        this.$notify({
          title: '菜單名稱為空',
          text: '請填寫菜單名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.crMenu()
        else if (type === 'up') this.upMenu()
      }
    },
    crMenu () {
      const menuInfo = this.menuInfoNew
      const url = this.base + this.id + '/menu'
      let data = {
        name: menuInfo.name
      }
      if (menuInfo.description) data['description'] = menuInfo.description
      if (menuInfo.remark) data['remark'] = menuInfo.remark
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            menu_id: response.data.menu_id,
            store_id: ''
          }
          let query = {
            copy_menu_id: this.$route.query.copy_menu_id
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuEditeUpJoin'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'upJoinMenu'
          }

          this.$router.push({ name, params, query })
        }
      })
    },
    delMenu () {
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功刪除菜單',
            duration: 3000,
            type: 'success',
            width: 400
          })

          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            store_id: ''
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuBuild'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'brandMenuTable'
          }

          this.$router.push({ name, params })
        }
      })
    },
    init () {
      switch (this.$route.name) {
        case 'upMenu':
        case 'StoreMenuEdite':
          this.getMenuContainer()
          break
        default:
          break
      }
    },
    goToBack () {
      console.log('goToBack')
      this.$router.go(-1)
    },
    getMenuContainer () {
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.menuInfo = response.data.menu
        }
      })
    },
    trigger (event) {
      if (event === 'delMenu') {
        this.delMenu()
      }
    },
    upMenu () {
      const menuInfo = this.menuInfoNew
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id
      let data = {
        name: menuInfo.name,
        description: menuInfo.description,
        remark: menuInfo.remark
      }
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            menu_id: this.$route.params.menu_id,
            store_id: ''
          }
          let query = {
            copy_menu_id: this.$route.query.copy_menu_id
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuEditeUpJoin'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'upJoinMenu'
          }

          this.$router.push({ name, params, query })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// MenuInfoFormTemp.vue?e39f4cb2